<template>
  <template-logo-img></template-logo-img>
</template>

<script lang="ts">

import templateLogoImg from '@/app-template/lib/components/LogoImg.vue';

export default {
  components: { templateLogoImg },
};
</script>